export default "__VITE_ASSET__7518019a__"